export const personal = [
    {
      title: "Sentimo",
      description: "A movie recommender system based upon sentimental analysis from the diary notes integrated within. This maps the combinational emotional to a particular genre type. A reinforcement ML model will be integrated.",
      imgUrl: 'sentimo',
      github: 'http://github.com/dakshgupta2002/sentimo',
      demo: 'https://www.youtube.com/watch?v=NLKazgWUNr0&ab_channel=DakshGupta',
      deploy: 'http://sentimo.surge.sh/'
    },
    {
      title: "Pathfinding Visualizer",
      description: "A algorithm based React app built to find the shortest path between two points using various graph traversal mechanisms such as BFS, DFS, Dijkstra. Extensive use of key events and animations!",
      imgUrl: 'pathfinder',
      github: 'https://github.com/dakshgupta2002/Pathfinding-Visualizer',
      deploy: 'https://pathfinding-visualizer-dakshgupta2002.surge.sh/'
    },
    {
      title: "Penalty calculator",
      description: "Built to help accountants, it calculates the running amount, cumulative interest, cumulative penalty of a installment based payment. Builds salary slips for employees of a firm on a monthly basis.",
      imgUrl: 'accountant',
      github: 'https://github.com/dakshgupta2002/EMI-calculator',
      deploy: 'http://accountants.surge.sh/'
    },
    {
      title: "Blockchain Interoperability",
      description: "Implemented HLTC (Hash Lock Time Contract) which keeps the initial request transaction valid for some time encrypted by a hash.",
      imgUrl: 'interoperable',
      github: 'https://github.com/dakshgupta2002/blockchain-interoperability'
    },
    {
      title: "Smart Door Unlock",
      description: "This improves the security and accessibility of ‘doors’ by its digitisation. Allows access of a particular door to multiple trusted members of the home/hostel and keeps a track of the history of when, where and who accessed the door.",
      imgUrl: 'smart-door-unlock',
      github: 'https://github.com/dakshgupta2002/smart-door-unlock'
    }
  ];

export const hackathons = [
  {
    title: "Augine",
    description: "It enhances shopping experience by providing algorithms that recommends customers with similar products based upon their preferences which can be taken for a virtual 3D try-on using Computer Vision and Neural Networks.",
    imgUrl: 'augine',
    github: 'https://github.com/the-quarantined/'
  },
  {
    title: "ChanPol",
    description: "It smoothens the process of collecting evidences against a crime, given the facial identity of suspect is known. It can track location, reports of location history and course of suspect's actions to monitor them using face extraction and detection.",
    imgUrl: 'chanpol',
    github: 'https://github.com/surveillance-bot',
    demo: 'https://www.youtube.com/watch?v=GbZLtqTGYDk&ab_channel=DakshGupta'
  },
  {
    title: "Cloud-Nine",
    description: "It is a Document-management-system which targets chunking of files while uploading/downloading to be efficient and enhance performance. You can create organizations to broadcast a file instantly.",
    imgUrl: 'cloudnine',
    demo: 'https://drive.google.com/file/d/1yBGK7nlNf2zVm3lYRcjGSdl0Iiy8-38Z/view',
    github: 'https://github.com/MAD-HAP',
    deploy: 'http://cloudnine-pi.vercel.app/'
  },
  {
    title: "Impeccable Data",
    description: "It's a portal for hotel managers wherein they can enter their customer records and can get the analytics as to what can be improved in their services; in order to increase the number of return customers and the revenue generated.",
    imgUrl: 'impeccable',
    deploy: 'https://insightify-dakshgupta2002.vercel.app/results',
    github: 'https://github.com/dakshgupta2002/Impeccable-Data'
  }
]

export const openSource = [
  {
    title: "Milan",
    imgUrl: 'milan',
    github: 'https://github.com/IAmTamal/Milan/commits?author=dakshgupta2002',
    deploy: 'https://milaan.vercel.app/'
  },
  {
    title: "URL-Minify",
    imgUrl: 'urlminify',
    github: 'https://github.com/BRAVO68WEB/url-minify/commits?author=dakshgupta2002',
    deploy: 'https://www.minfy.xyz/'
  },
  {
    title: "Pictionary",
    imgUrl: 'pictionary',
    github: 'https://github.com/gdscjgec/Pictionary/commits?author=dakshgupta2002',
    deploy: 'https://gdscjgec.github.io/Pictionary'
  },
  {
    title: "Poll it Up",
    imgUrl: 'pollitup',
    github: 'https://github.com/agamjotsingh18/pollitup/commits?author=dakshgupta2002',
    deploy: 'https://pollitup.netlify.app/'
  },
  {
    title: "PlanZap",
    imgUrl: 'planzap',
    github: 'https://github.com/SaraswatGit/PlanZap/commits?author=dakshgupta2002',
    deploy: 'https://planzap.netlify.app/',
    demo: 'https://drive.google.com/file/d/1t33jODX3xZmITv0QUnhFlc7pja-yHX24/view'
  }
]